module.exports = __webpack_public_path__ + "f990d40bcd2c68b584094b72bc4869cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/img/bucket-icon.png
// module id = 21
// module chunks = 0